import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  // SingleAction,
  Sort,
  TabActionDialog
} from "@saleor/types";
import urlJoin from "url-join";

import { stringifyQs } from "../utils/urls";

export const insCommentSection = "/inscomment/";

export const insCommentListPath = insCommentSection;

export enum InsCommentListUrlSortField {
  name = "name",
  created = "created"
}
export type InsCommentListUrlSort = Sort<InsCommentListUrlSortField>;
export enum InsCommentListUrlFiltersEnum {
  query = "query",
  isVisible = "isVisible"
}
export enum InsCommentListUrlFiltersWithMultipleValuesEnum {
  source = "source",
  parentType = "parentType"
}

export type InsCommentListUrlFilters = Filters<InsCommentListUrlFiltersEnum> &
  FiltersWithMultipleValues<InsCommentListUrlFiltersWithMultipleValuesEnum>;

export type InsCommentListUrlDialog = TabActionDialog;

export type InsCommentListUrlQueryParams = Pagination &
  InsCommentListUrlSort &
  InsCommentListUrlFilters &
  Dialog<InsCommentListUrlDialog> &
  BulkAction &
  ActiveTab;
export const commentListUrl = (params?: InsCommentListUrlQueryParams) =>
  insCommentListPath + "?" + stringifyQs(params);

// export type InsCommentPathUrlQueryParams =
export const insCommentPath = (id: string) => urlJoin(insCommentSection, id);

export const insCommentUrl = (id: string) =>
  insCommentPath(encodeURIComponent(id)) + "?";
